export default {
  coming_soon: "به زودی",
  selectAll: "انتخاب همه",
  assets: "دارایی",
  new: "جدید",
  seeMore: "مشاهده بیشتر",
  download: "دانلود",
  cancel: "لغو",
  confirm: "تایید",
  cancelAction: "انصراف",
  back: "بازگشت",
  analyst:"تحلیلگر"
};
